import React, { useEffect, useState } from 'react';
import { Box,Typography} from "@mui/material";
import { get } from '../../../../utils/api';
import MultiColumns from '../MultiColumns';

import { companyId } from "../../../../utils/companyId";

const CustomerRelation = ({isEditing}) => {
    const[data,setData]=useState([]);
    useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await get(
              `/social/customer_relations/${companyId}`
            );
            console.log("API response:", response.data);
            console.log(response.data, "response.data");
            // Update state only if data is available
            setData(response?.data)
           
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
        fetchData();
    },[])

    const questionary= [
      {mainheading: "Customer Satisfaction Score",gridSize:{xs:12}},
      { key: "customerSatisfactionScore.netPromoterScore",question:"Net Promoter Score"},
      {key: "customerSatisfactionScore.customerSatisfactionIndex",
        question: "Customer Satisfaction Index"},
         {mainheading:"Data Privacy and Security Incidents",gridSize:{xs:12}},
      {
        key: "dataPrivacyAndSecurityIncidents.high.numberOfBreaches",
        question:"High Risk",gridSize:{xs: 12, sm: 6, md: 3}},
      {key: "dataPrivacyAndSecurityIncidents.medium.numberOfBreaches",
        question:"Medium Risk",gridSize:{xs: 12, sm: 6, md: 3}},

      {key: "dataPrivacyAndSecurityIncidents.low.numberOfBreaches", gridSize:{xs: 12, sm: 6, md: 3},question: "Low Risk" },
      {key: "dataPrivacyAndSecurityIncidents.totalBreaches", gridSize:{xs: 12, sm: 6, md: 3},question: "Total" },
      {mainheading:"Volunteer Hours",gridSize:{xs:12}},
      { key: "productQualityAndSafety.product",
         question: "Product"},
      {key:"productQualityAndSafety.numberOfProductsRecalled",question:"Volunteer Hours"}
    ]

  return (
    <>
    <MultiColumns title="Customer Relations"
    url={`/social/customer-relation`}
     questionary={questionary} columns={2} data={data} isEditing={isEditing}/>
    </>
)
}

export default CustomerRelation;